import { observable } from "mobx";
import RefundApprovalType from "./refundApprovalType";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class RefundApprovalResponse {
  @observable
  approvalType!: RefundApprovalType;
}
